export const ADMIN_EMAILS = [
  'luca.biddeci@gmail.com',
  'mbho.alc@gmail.com'
]

export const normalizeAccessEmail = email =>
  String(email || '').trim().toLowerCase()

export const isAdminEmail = email =>
  ADMIN_EMAILS.includes(normalizeAccessEmail(email))
